import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pickup--notice",
  "use": "icon-pickup--notice-usage",
  "viewBox": "0 0 19 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 19 16\" id=\"icon-pickup--notice\"><path d=\"m9.263 2.097 7.394 12.85H1.869l7.394-12.85Zm0-2.097L0 16h18.526L9.263 0Zm.842 11.79H8.421v1.684h1.684V11.79Zm0-5.053H8.421v4h1.684v-4Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol